export default "__VITE_ASSET__DAsHft0U__"